module.exports = __webpack_public_path__ + "img/spinomenal.3f177a7c.svg";